import Handlebars from 'handlebars'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { ReportPayload } from '@utils/report.util'
import { sanitizeDocumentHtml } from '@utils/sanitize-html.util'
import type { RootState } from '@store/index'

Handlebars.registerHelper('eq', (a: unknown, b: unknown) => a === b)

export function ReportPreview({
  payload,
}: {
  payload: ReportPayload
}): React.ReactElement {
  const reportsTemplate = useSelector(
    (state: RootState) => state.reportsTemplate.data,
  )

  const compiledTemplate = useMemo(() => {
    if (!reportsTemplate?.html) {
      return null
    }

    return Handlebars.compile(reportsTemplate.html)
  }, [reportsTemplate?.html])

  const html = useMemo(() => {
    if (!compiledTemplate) {
      return ''
    }

    return compiledTemplate(payload)
  }, [compiledTemplate, payload])

  if (!reportsTemplate?.html) {
    return <></>
  }

  return (
    <div className="reports-preview-content">
      <style>{reportsTemplate.css}</style>

      <div dangerouslySetInnerHTML={{ __html: sanitizeDocumentHtml(html) }} />
    </div>
  )
}
